import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/prep_guides')({
  component: Outlet,
  loader: () => ({ crumb: 'Prep Guides' }),
});
